/** This file is auto generated by convertSvgToJsx.ts */

import React from 'react'
const wheelchair_medium = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M13.62 20.91c-2.1 2.457-5.96 2.8-8.478.751-2.518-2.048-2.87-5.814-.77-8.27m7.633-9.822c0 1.42-1.179 2.57-2.633 2.57s-2.633-1.15-2.633-2.57C6.739 2.15 7.918 1 9.372 1s2.633 1.15 2.633 2.57Zm6.37 17.457-2.858-3.347a1.53 1.53 0 0 0-1.154-.53H8.996c-.82 0-1.505-.668-1.505-1.468V9.81c0-.8.685-1.468 1.505-1.468h3.821c1.937 0 1.937 2.936 0 2.936h-2.316v2.936h3.862A4.6 4.6 0 0 1 17.83 15.8l2.852 3.346c1.15 1.463-1.109 3.167-2.307 1.881Z"
    />
  </svg>
)
export default wheelchair_medium
